import React from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import FilesCombobox from "Components/Files/FilesCombobox";
import InvoicesCombobox from "Components/Invoice/InvoicesCombobox";
import PriceField from "Components/UI/Form/PriceField";
import DateWithClear from "Components/UI/Form/DateWithClear";

export default function EndcustomerPrintedFormGeneral({
  formData,
  invoices,
  files,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2} sx={{ marginTop: "10px" }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Id"
            label="Id"
            value={formData.Id}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            focused
            name="Amount"
            onChange={(newVal) => handleInputChange("Amount", newVal)}
            label="Belopp"
            value={formData.Amount}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>
        {/* Faktura ID */}
        <Grid item xs={12} sm={6} md={4}>
          <InvoicesCombobox
            label={"Faktura ID"}
            selectedInvoiceID={formData.InvoiceId ? formData.InvoiceId : null}
            onChange={(newVal) => handleInputChange("InvoiceId", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FilesCombobox
            label="Fil"
            files={files}
            selectedFileID={formData.FileId}
            onChange={(newVal) => handleInputChange("FileId", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="OCR"
            onChange={(e) => handleInputChange("OCR", e.target.value)}
            label="OCR"
            value={formData.OCR}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="EndCustomerName"
            onChange={(e) =>
              handleInputChange("EndCustomerName", e.target.value)
            }
            label="Namn"
            value={formData.EndCustomerName}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="Senaste betalning"
            value={dayjs(formData.LastPayment)}
            onChange={(newVal) =>
              handleInputChange(
                "LastPayment",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
